import _ from 'lodash';

import { error } from 'State/actions';
import getDatabase from 'Common/DB';
import { getDatabaseName } from 'State/selectors';
import * as POSSelectors from 'PointOfSale/selectors';
import { StatusEnum } from 'Common/Constants/Enumeration/StatusEnum';
import { sortByLastNameFirstName } from 'PointOfSale/modules/common/helpers';
import {
  SessionTypes,
  SearchStatuses,
} from 'PointOfSale/modules/common/constants';
import { GENERIC_ACCOUNT_IDS } from 'Common/Constants';
import { getOnline } from 'State/selectors';
import { getStudents } from 'PointOfSale/state/actions';

import * as types from './types';

export const showLookup = (showLookup) => ({
  type: types.SHOW_LOOKUP,
  payload: showLookup,
});

export const updateLookUpQuery = (query) => ({
  type: types.UPDATE_SHOW_LOOKUP_QUERY,
  payload: query,
});

export const search = () => async (dispatch, getState, MPWWebAPI) => {
  dispatch(lookupLoading(true));
  const state = getState();
  const databaseName = getDatabaseName(state);
  const DB = await getDatabase(databaseName);
  const selectedSite = POSSelectors.getSelectedSiteDetails(state);
  const lookUpQuery = POSSelectors.getQuery(state);
  const searchTerm = _.trim(lookUpQuery.term || '');
  const visitingStudent = lookUpQuery.visitingStudent;
  const activeSession = POSSelectors.getActiveSession(state);
  const PrimarySiteId = selectedSite.Id;
  const online = getOnline(state);
  let searchResult = [];
  let message = '';
  let siteIds = [PrimarySiteId];

  try {
    const site = await DB.Sites.where({
      Id: PrimarySiteId,
      PrimarySiteId,
    }).first();

    if (site) {
      const secondarySiteIds = site.SecondarySites.map((ss) => ss.Id);
      siteIds.push(secondarySiteIds);
    }
    siteIds = _.uniq(_.flatten(siteIds));

    switch (activeSession) {
      case SessionTypes.Teacher: {
        searchResult = await DB.Students.where('Teacher')
          .startsWithIgnoreCase(searchTerm)
          .and((student) => student.Teacher && student.Teacher !== '')
          .and((student) => siteIds.includes(student.SiteId))
          .and((student) => student.StatusCurrent !== StatusEnum.Withdrawn) //ignore withdrawn students
          .toArray();
        searchResult = _.uniq(searchResult.map((x) => x.Teacher));
        break;
      }
      case SessionTypes.Queue: {
        if (searchTerm) {
          // Anytime we are online and requesting visiting studnets, request from the api. otherwise, use the local database.
          if (online && visitingStudent) {
            const students = await getStudents({
              search: searchTerm,
              MPWWebAPI,
            });

            searchResult = sortByLastNameFirstName(
              students.filter(
                (student) =>
                  SearchStatuses.includes(student.StatusCurrent) &&
                  (searchTerm === student.Id ||
                    !GENERIC_ACCOUNT_IDS.has(student.Id))
              )
            );
          } else {
            searchResult = await DB.Students.where('LastName')
              .startsWithIgnoreCase(searchTerm)
              .or('FirstName')
              .startsWithIgnoreCase(searchTerm)
              .or('Id')
              .startsWithIgnoreCase(searchTerm)
              .or('ServingNumber')
              .startsWithIgnoreCase(searchTerm)
              .and(
                (
                  student // if visitingStudent is enabled, then return all students that match, else only the student with PrimarySiteId that match
                ) => {
                  if (visitingStudent) {
                    return true;
                  }
                  // if visiting student is not selected, we want to return generic accounts still
                  if (GENERIC_ACCOUNT_IDS.has(student.Id)) {
                    return true;
                  }
                  return siteIds.includes(student.SiteId);
                }
              )
              .and((student) => SearchStatuses.includes(student.StatusCurrent))
              .toArray(sortByLastNameFirstName);
          }

          // Add a message when we are offline and requesting visiting students.
          if (!online && visitingStudent) {
            message = "Visiting students aren't available in offline mode";
          }
        }
        break;
      }

      default:
        break;
    }
  } catch (err) {
    dispatch(error(types.LOOKUP_ERROR, err));
  }

  const currentState = getState();
  const currentSearchTerm = POSSelectors.getQuery(currentState).term || '';

  if (currentSearchTerm === searchTerm) {
    dispatch({
      type: types.LOOK_SEARCH,
      payload: {
        results: searchResult,
        message,
      },
    });
  }
  dispatch(lookupLoading(false));
};

export const lookupLoading = (loading) => ({
  type: types.LOOKUP_LOADING,
  payload: loading,
});

export const resetLookup = () => ({
  type: types.RESET_LOOKUP,
});



// WEBPACK FOOTER //
// ./src/pages/pointofsale/modules/lookup/state/actions.js